import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import pure from "recompose/pure";

interface IUserIconProps extends SvgIconProps {}

let User = (props: IUserIconProps) => (
	<SvgIcon {...props} viewBox="0 0 33 33">
		<circle cx="16" cy="13" r="4" stroke="black" strokeWidth="2" />
		<path
			d="M23 24C23 20.134 19.866 17 16 17C12.134 17 9 20.134 9 24"
			stroke="black"
			strokeWidth="2"
		/>
	</SvgIcon>
);

// @ts-ignore
User = pure(User);
// @ts-ignore
User.displayName = "UserIcon";
// @ts-ignore
User.muiName = "SvgIcon";

export default User;
